import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getHotels, hideSideNavigation } from '../../store/actions/index';

import Spinner from '../../components/UI/Spinner/Spinner';
import Loader from '../../components/UI/Loader/Loader';

import TupleHotel from '../../components/Hotel/HotelTuple/HotelTuple';

import HotelHeader from '../../components/Hotel/HotelHeader/HotelHeader';
import SearchResultWrapper from '../../components/UI/Wrappers/SearchResultWrapper/SearchResultWrapper';

class Hotels extends Component {
    componentDidMount() {
        window.addEventListener('scroll', this.handleOnScroll);
        this.props.onHideSideNavigation();
        this.props.onGetHotels(this.props.location.search);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleOnScroll);
    }

    handleOnScroll = () => {
        const scrollTop = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
        const scrollHeight = (document.documentElement && document.documentElement.scrollHeight) || document.body.scrollHeight;
        const clientHeight = document.documentElement.clientHeight || window.innerHeight;
        const scrolledToBottom = Math.ceil(scrollTop + clientHeight) >= scrollHeight;

        if (scrolledToBottom) {
            this.props.onGetHotels(this.props.location.search, true);
        }
    }

    render() {
        let hotels = (
            <div>
                <Spinner />
                <Loader type='hotel' />
            </div>
        );

        if(!this.props.loading) {
            hotels = this.props.hotelRates.map((hotelRate) => <TupleHotel key={hotelRate.id} hotelRate={hotelRate} hotel={this.props.hotels.find(hotel => hotel.id === hotelRate.id)} />)
        }

        return (
            <SearchResultWrapper>
                <HotelHeader/>    
                {hotels}
                {/* {(() => {
                    if (this.props.revisedDataLoading) {
                        return (
                            <div>
                                Hola
                            </div>
                        )
                    } else {
                        return <div>Hello</div>
                    }
                })()} */}
            </SearchResultWrapper>
        );     
    }
};

const mapStateToProps = state => {
    return {
        loading: state.hotels.loading,
        revisedDataLoading: state.hotels.revisedDataLoading,
        hotels: state.hotels.hotels,
        hotelRates: state.hotels.hotelRates
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onGetHotels: (hotelSearchParams, isNew) => dispatch(getHotels(hotelSearchParams, isNew)),
        onHideSideNavigation: () => dispatch(hideSideNavigation()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Hotels);


// WEBPACK FOOTER //
// ./src/containers/Hotels/Hotels.js